<template>
  <div v-if="video.id" class="sidearm-mm-video-background absolute w-100 h-100">
    <video
      playsinline
      muted
      autoplay
      loop
      class="sidearm-mm-video-background__video object-fit-cover object-fit-positioning"
      data-autoplay
    >
      <source :src="video.id" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  props: {
    video: { type: Object, required: true }
  }
};
</script>

<style lang="scss" scoped>
.#{$prefix}-video-background {
  left: 0;
  top: 0;

  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color-black, 0.8);
  }

  &__video {
    left: 0;
    top: 0;
  }
}
</style>
